<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="three_lever" src="@/assets/images/icon_product.png" alt=""/>产品展厅</span>
      <el-steps :active="1" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 产品选择" icon="el-icon-thumb"></el-step>
        <el-step title="2 购物车确认" icon="el-icon-shopping-cart-full"></el-step>
        <el-step title="3 完善订单信息" icon="el-icon-edit"></el-step>
        <el-step title="4 提交完成订单" icon="el-icon-document-checked"></el-step>
      </el-steps>

      <el-main class="query">
        <span class="sp1">商品筛选</span><span class="sp2">（点击下方条件进行选择，再次点击取消条件）</span>
        <el-divider class="div"></el-divider>
        <span class="sp3">类别：</span>
        <el-checkbox-group class="gp" v-model="checkboxGroup" size="mini" @change="handleCheckedGroupChange">
          <el-checkbox-button v-for="group in groupLists" :label="group.groupNumber" :key="group.groupNumber">{{group.groupName}}</el-checkbox-button>
        </el-checkbox-group>
        <el-divider class="div"></el-divider>
        <span class="sp3">品牌：</span>
        <el-checkbox-group class="gp" v-model="checkboxLogo" size="mini" @change="handleCheckedLogoChange">
          <el-checkbox-button v-for="logo in logoLists" :label="logo.logoName" :key="logo.logoName">{{logo.logoName}}</el-checkbox-button>
        </el-checkbox-group>
        <el-divider class="div"></el-divider>
        <span class="sp3">规格：</span>
        <el-checkbox-group class="gp" v-model="checkboxModel" size="mini" @change="handleCheckedModelChange">
          <el-checkbox-button v-for="model in modelLists" :label="model.model" :key="model.model+model.spec">{{model.model}}</el-checkbox-button>
        </el-checkbox-group>
        <el-divider class="div"></el-divider>
      </el-main>
      <el-main class="list">
        <span class="sp1">商品列表</span>
        <el-button class="but but1 addCartBtn" size="small" @click="batchAddCart">批量加入购物车</el-button>
        <el-button class="but but2" size="small" @click="queryPageListByFilter(1)">查询物料</el-button>
        <el-input class="input" type="text" prefix-icon="el-icon-search" size="small" v-model="search" placeholder="请输入关键词"></el-input>
        <el-divider class="div1"></el-divider>

        <el-checkbox-group v-model="checkedItems" @change="handleCheckedItemsChange">
        <div class="productLists" v-loading="loading">
          <div class="product" v-if="goodLists.length !== 0" v-for="(good,index) in goodLists">
            <el-checkbox :label="good" :key="good.number"><br>
              <!--<img class="simple" src="@/assets/images/simple.jpg" alt=""/>-->
              <!--优先展示已维护的物料头图-->
              <img class="simple" v-if="good.commerceVo.id != null" :src="good.commerceVo.headUri" alt=""/>
              <img class="simple" v-else :src="'https://minio.godaji.com/minio/osp/'+good.number+'.jpg'" onerror="this.src='https://minio.godaji.com/minio/osp/simple.jpg';this.onerror=null;" alt=""/>
            </el-checkbox>
            <div>
              <span class="sp6">名称：{{good.name}}</span>
            </div>
            <div>
              <span class="sp4">代号：{{good.shortName}}</span>
            </div>
            <div>
              <span class="sp4">规格：{{good.model}}</span>
            </div>
            <div>
              <span class="sp4">编码：{{good.number}}</span>
            </div>
<!--            <div>-->
<!--              <span class="sp4">简称：{{good.helpCode}}</span>-->
<!--            </div>-->
<!--            <div>-->
<!--              <span class="sp4">商标：{{good.registeredMark}}</span>-->
<!--            </div>-->
            <div style="margin-top: 8px">
              <span v-if="good.baseConversionRate == null">
                <span class="sp6" v-if="good.saleMeasurement.number === 'GONGJIN'">公斤：
                  <el-input-number v-model="good.weight" :min="1" size="mini" label="公斤" @change="changeDun(index)"></el-input-number>
                </span>
                <span class="sp6" v-else>吨数：
                  <el-input-number v-model="good.weight" :min="0.001" size="mini" label="吨数" @change="changeDun(index)"></el-input-number>
                </span>
                <br>
                <span class="sp6" v-if="good.packagingSpecification === '0'">包数：
                  <el-input-number v-model="good.amount" :min="0" size="mini" label="包数" style="margin-top: 6px" disabled></el-input-number>
                </span>
                <span class="sp6" v-else>包数：
                    <el-input-number v-model="good.amount" :min="1" size="mini" label="包数" @change="changeAmt(index)" style="margin-top: 6px"></el-input-number>
                </span>
              </span>
              <span v-else>
                <span class="sp6">{{good.saleMeasurement.name.length === 2 ? good.saleMeasurement.name : good.saleMeasurement.name+'数'}}：
                  <el-input-number v-model="good.weight" :min="1" :step="good.saleMeasurement.baseConversionRate" size="mini" label="销售数量" @change="changeSale(index)"></el-input-number>
                </span><br>
                <span class="sp6">{{good.assistMeasurement.name.length === 2 ? good.assistMeasurement.name : good.assistMeasurement.name+'数'}}：
                  <el-input-number v-model="good.amount" :min="1" size="mini" label="辅助数量" @change="changeAss(index)" style="margin-top: 6px;"></el-input-number>
                </span>
              </span>
            </div>
            <div style="margin-top: 8px">
              <el-button class="addCartBtn" size="small" @click="addCart(good)">
                <span class="sp5">加入购物车</span>
              </el-button>
              <el-button class="collectBtn" size="small" @click="addFavorites(good)">
                <span class="sp5">收藏</span>
              </el-button>
            </div>
          </div>
        </div>
        </el-checkbox-group>
      </el-main>
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-count="pageCount"
        :page-size="pageSize"
        :total="total"
        style="margin-top: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>

import {queryPageListByFilter} from "../../../api/system/good";
import {saveCart} from "../../../api/system/cart";
import {saveFavorites} from "../../../api/system/favorites";
import {getMaterialGroupList, getMaterialLogoList, getMaterialModelList} from "../../../api/system/materialView";

export default {
name: "index",
  data(){
    return{
      currentUser:{},
      saleOrgId:'',
      saleOrgName:'',
      goodLists:[],//物料列表
      search:'',//模糊查询
      checkboxGroup:[],
      checkboxLogo:[],
      checkboxModel:[],
      groupLists:[],
      logoLists:[],
      modelLists:[],
      currentPage:1,
      pageCount:1,
      pageSize:1,
      total:0,
      checkedItems:[],
      loading:false
    }
  },
  mounted(){
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")

    this.getMaterialGroupList() //获取分类列表
    this.getMaterialLogoList() //获取品牌列表
    this.getMaterialModelList() //获取规格列表
    this.queryPageListByFilter(1) //获取物料列表
  },
  methods:{
    changeCompany(){
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    getMaterialGroupList(){
      let param = {'saleOrgId':this.saleOrgId,'cusNumber':this.currentUser.username}
      getMaterialGroupList(param).then(res => {
        // console.log('物料分类信息')
        // console.log(res.data)
        this.groupLists = res.data
      }).catch(()=>{

      })
    },
    getMaterialLogoList(){
      let param = {'saleOrgId':this.saleOrgId,'cusNumber':this.currentUser.username}
      getMaterialLogoList(param).then(res => {
        // console.log('物料品牌信息')
        // console.log(res.data)
        this.logoLists = res.data
      }).catch(()=>{

      })
    },
    getMaterialModelList(){
      let param = {'saleOrgId':this.saleOrgId,'cusNumber':this.currentUser.username}
      getMaterialModelList(param).then(res => {
        // console.log('物料规格信息')
        // console.log(res.data)
        this.modelLists = res.data
      }).catch(()=>{

      })
    },
    //分页获取物料
    queryPageListByFilter(currentPage){
      this.loading = true
      let params = {}
      params.current = currentPage
      params.size = 10
      params.tenantId = '603609'
      params.name = this.search
      params.orgSales = [{'id': this.saleOrgId}]
      params.saleOrgId = this.saleOrgId
      params.cusNumber = this.currentUser.username

      //添加分类信息
      let groupList = []
      for(let i = 0; i < this.checkboxGroup.length; i++){
        let group = {}
        group.groupNumber = this.checkboxGroup[i]
        groupList.push(group)
      }
      params.groupLists = groupList

      //添加品牌信息
      let logoList = []
      for(let i = 0; i < this.checkboxLogo.length; i++){
        let logo = {}
        // console.log(this.checkboxLogo)
        logo.logoName = this.checkboxLogo[i]
        logoList.push(logo)
      }
      params.logoLists = logoList

      //添加规格信息
      let modelList = []
      for(let i = 0; i < this.checkboxModel.length; i++){
        let model = {}
        // console.log(this.checkboxModel)
        model.model = this.checkboxModel[i]
        modelList.push(model)
      }
      params.modelLists = modelList

      // console.log(params)
      queryPageListByFilter(params).then(res =>{
        this.goodLists = []
        if(res.data.records.length > 0){
          // console.log(res)
          this.total = res.data.total;
          this.currentPage = res.data.current
          this.pageCount = res.data.pages
          this.pageSize = res.data.size
          for(let i in res.data.records){
            let goods = {};
            goods.id = res.data.records[i].id;
            goods.name =res.data.records[i].name;
            goods.number = res.data.records[i].number;
            goods.model = res.data.records[i].model;
            goods.registeredMark = res.data.records[i].registeredMark == null ? "其他" : res.data.records[i].registeredMark;
            goods.shortName = res.data.records[i].shortName;
            goods.helpCode = res.data.records[i].helpCode;
            goods.commerceVo = res.data.records[i].commerceVo //商品详情
            goods.packagingSpecification = res.data.records[i].packagingSpecification;
            goods.baseConversionRate = res.data.records[i].baseConversionRate;
            goods.assistMeasurement = res.data.records[i].assistMeasurement;
            goods.saleMeasurement = res.data.records[i].saleMeasurement;
            //判断是否使用辅助计量单位
            if(goods.baseConversionRate != null){
              goods.amount = 1
              goods.weight = this.floatMul(goods.amount,goods.baseConversionRate)
            }
            //判断销售计量单位数量是否存在
            else if(res.data.records[i].weight === undefined){
              //判断规格是否为0，即是否为散装料，散装料设置辅助单位数量为0
              if(goods.packagingSpecification === '0'){
                goods.amount = '0'
                if(goods.saleMeasurement.number === 'GONGJIN'){
                  goods.weight = 1000
                }else{
                  goods.weight = 1
                }
              }else{
                //判断计量单位是否为公斤
                if(goods.saleMeasurement.number === 'GONGJIN'){
                  goods.weight = 1000
                  let res = this.floatDivision(goods.weight,goods.packagingSpecification)
                  if(typeof res === 'number' && res%1 === 0) {
                    goods.amount = res
                  }else{
                    goods.amount = Math.ceil(res)
                    goods.weight = this.floatMul(goods.amount, goods.packagingSpecification)
                  }
                }else{
                  goods.weight = 1
                  let res = this.floatDivision(this.floatMul(goods.weight,1000),goods.packagingSpecification)
                  if(typeof res === 'number' && res%1 === 0) {
                    goods.amount = res
                  }else{
                    goods.amount = Math.ceil(res)
                    goods.weight = this.floatDivision(this.floatMul(goods.amount, goods.packagingSpecification),1000)
                  }
                }
              }
            }
            this.goodLists.push(goods);
          }
        }else{
          this.$modal.msg("没有符合条件的商品")
          this.total = 0
          this.currentPage = 1
          this.pageCount = 1
          this.pageSize = 1
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
      this.checkedItems = []
    },
    //改变页码触发
    pageChange(){
      this.queryPageListByFilter(this.currentPage)
    },
    //加入购物车
    addCart(goods){
      let goodsList = []
      let goodsTemp= {}
      goodsTemp.goodsId=goods.id;
      goodsTemp.goodsCode=goods.number;
      goodsTemp.goodsName=goods.name;
      goodsTemp.goodsRule=goods.model;
      goodsTemp.goodsAlias=goods.shortName;
      if (goods.registeredMark !== null && goods.registeredMark !== '') {
        goodsTemp.logo = goods.registeredMark;
      } else {
        goodsTemp.logo = '无';
      }
      goodsTemp.goodsSpec=goods.packagingSpecification;
      goodsTemp.weight=goods.weight;
      goodsTemp.amount=goods.amount;
      if(goods.commerceVo.id !== null){
        goodsTemp.headUri=goods.commerceVo.headUri;
      } else {
        goodsTemp.headUri=null
      }
      goodsTemp.orgSaleId = this.saleOrgId;
      goodsTemp.baseConversionRate = goods.baseConversionRate
      goodsTemp.assistUnitId = goods.assistMeasurement == null ? null : goods.assistMeasurement.id
      goodsTemp.assistUnitName = goods.assistMeasurement == null ? null : goods.assistMeasurement.name
      goodsTemp.baseUnitId = goods.saleMeasurement.id
      goodsTemp.baseUnitName = goods.saleMeasurement.name

      goodsList.push(goodsTemp)
      // console.log(goodsList)
      saveCart(goodsList).then(res => {
        if(res.code === 200){
          this.openMsg()
        }else{
          this.$modal.msgError("添加到购物车失败，请重试");
        }
      });
    },
    //批量加入购物车
    batchAddCart(){
      // console.log(this.selectedItems)
      if(this.selectedItems === undefined || this.selectedItems === 0){
        this.$modal.msgWarning("请选择需要加入购物车的产品");
        return
      }
      let goodsList = [];
      for(let i = 0; i < this.checkedItems.length; i++){
        let goodsTemp = {}
        goodsTemp.goodsId = this.checkedItems[i].id;
        goodsTemp.goodsCode = this.checkedItems[i].number;
        goodsTemp.goodsName = this.checkedItems[i].name;
        goodsTemp.goodsRule = this.checkedItems[i].model;
        goodsTemp.goodsAlias = this.checkedItems[i].shortName;
        goodsTemp.goodsSpec = this.checkedItems[i].packagingSpecification;
        goodsTemp.logo = this.checkedItems[i].registeredMark;
        goodsTemp.weight = this.checkedItems[i].weight;
        goodsTemp.amount = this.checkedItems[i].amount;
        if(this.checkedItems[i].commerceVo.id !== null){
          goodsTemp.headUri=this.checkedItems[i].commerceVo.headUri;
        }else {
          goodsTemp.headUri=null
        }
        goodsTemp.orgSaleId = this.saleOrgId;
        goodsTemp.baseConversionRate = this.checkedItems[i].baseConversionRate
        goodsTemp.assistUnitId = this.checkedItems[i].assistMeasurement == null ? null : this.checkedItems[i].assistMeasurement.id
        goodsTemp.assistUnitName = this.checkedItems[i].assistMeasurement == null ? null : this.checkedItems[i].assistMeasurement.name
        goodsTemp.baseUnitId = this.checkedItems[i].saleMeasurement.id
        goodsTemp.baseUnitName = this.checkedItems[i].saleMeasurement.name

        goodsList.push(goodsTemp)
      }
      // console.log(goodsList)
      saveCart(goodsList).then(res => {
        if(res.code === 200){
          this.openMsg()
        }else {
          this.$modal.msgError("批量添加购物车失败，请重试");
        }
      })
    },
    openMsg() {
      this.$confirm('商品已成功加入购物车!', '信息', {
        confirmButtonText: '去结算',
        cancelButtonText: '继续购物',
        type: 'success'
      }).then(() => {
        this.toCart()
      }).catch(() => {
        console.log('取消')
      });
    },
    addFavorites(goods) {
      let goodsList = []
      let goodsTemp = {}
      goodsTemp.goodsId = goods.id;
      goodsTemp.goodsCode = goods.number;
      goodsTemp.goodsName = goods.name;
      goodsTemp.goodsRule = goods.model;
      goodsTemp.goodsAlias = goods.shortName;
      if (goods.goodRegisteredMark != null && goods.registeredMark !== '') {
        goodsTemp.logo = goods.registeredMark;
      } else {
        goodsTemp.logo = '无';
      }
      goodsTemp.goodsSpec=goods.packagingSpecification;
      goodsTemp.weight=goods.weight;
      goodsTemp.amount=goods.amount;
      if(goods.commerceVo.id !== null){
        goodsTemp.headUri=goods.commerceVo.headUri;
      } else {
        goodsTemp.headUri=null
      }
      goodsTemp.orgSaleId = this.saleOrgId;
      goodsTemp.baseConversionRate = goods.baseConversionRate
      goodsTemp.assistUnitId = goods.assistMeasurement?.id
      goodsTemp.assistUnitName = goods.assistMeasurement?.name
      goodsTemp.baseUnitId = goods.saleMeasurement.id
      goodsTemp.baseUnitName = goods.saleMeasurement.name
      goodsList.push(goodsTemp)
      // console.log(goodsList)
      saveFavorites(goodsList).then(res => {
        if(res.code === 200){
          this.$modal.msgSuccess("加入收藏夹成功")
        }else {
          this.$modal.msgError("加入收藏夹失败，请重试")
        }
      })
    },
    changeDun (e) {
      if(this.goodLists[e].packagingSpecification !== '0'){
        if(this.goodLists[e].saleMeasurement.number === 'GONGJIN'){
          let res = this.floatDivision(this.goodLists[e].weight, this.goodLists[e].packagingSpecification)
          if(typeof res === 'number' && res%1 === 0){
            this.goodLists[e].amount = res
          }else{
            //向上取整
            this.goodLists[e].amount = Math.ceil(res)
            // this.changeAmt(e)
          }
        }else{
          let res = this.floatDivision(this.floatMul(this.goodLists[e].weight,1000), this.goodLists[e].packagingSpecification)
          if(typeof res === 'number' && res%1 === 0){
            this.goodLists[e].amount = res
          }else{
            //向上取整
            this.goodLists[e].amount = Math.ceil(res)
            this.changeAmt(e)
          }
        }
      }
    },
    changeAmt (e) {
      if(this.goodLists[e].amount === 0){
        this.goodLists[e].amount = 1
      }
      if(this.goodLists[e].saleMeasurement.number === 'GONGJIN'){
        this.goodLists[e].weight = this.floatMul(this.goodLists[e].amount, this.goodLists[e].packagingSpecification)
      }else {
        this.goodLists[e].weight = this.floatDivision(this.floatMul(this.goodLists[e].amount, this.goodLists[e].packagingSpecification),1000)
      }
    },
    changeSale (e) {
      let res = this.floatDivision(this.goodLists[e].weight, this.goodLists[e].baseConversionRate)
      if(typeof res === 'number' && res%1 === 0){
        this.goodLists[e].amount = res
      }else{
        //向上取整
        this.goodLists[e].amount = Math.ceil(res)
        this.changeAss(e)
      }
    },
    changeAss (e) {
      this.goodLists[e].weight = this.floatMul(this.goodLists[e].amount, this.goodLists[e].baseConversionRate)
    },
    toCart(){
      this.$router.push('/cart/cart');
    },
    handleCheckedItemsChange(value) {
      let checkedCount = value.length;
      this.selectedItems = checkedCount
      // console.log(this.checkedItems)
    },
    handleCheckedGroupChange(value){
      let checkedGroup = value;
      this.checkboxGroup = checkedGroup
      this.queryPageListByFilter(1)
      // console.log(this.checkboxGroup)
    },
    handleCheckedLogoChange(value){
      let checkedLogo = value;
      this.checkboxLogo = checkedLogo
      this.queryPageListByFilter(1)
      // console.log(this.checkboxLogo)
    },
    handleCheckedModelChange(value){
      let checkedModel = value;
      this.checkboxModel = checkedModel
      this.queryPageListByFilter(1)
      // console.log(this.checkboxModel)
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    //小数乘法
    floatMul(a, b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, m + n); //将数字转换为整数的最大倍数
      return Number(d.replace(".", "")) * Number(e.replace(".", "")) / maxInt;
    },
    //小数除法
    floatDivision(a, b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, Math.max(n, m)); //将数字转换为整数的最大倍数
      let aInt = this.floatMul(a, maxInt);
      let bInt = this.floatMul(b, maxInt);
      return aInt / bInt;
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
    margin-top: -10px;
  }
  .three_lever{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .simple{
    width: 180px;
    height: 180px;
    margin-top: -20px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .query{
    width: 100%;
    /*height: 250px;*/
    box-sizing: border-box;
    border: 1px solid rgb(196, 196, 196);
    margin-top: 10px;
  }
  .sp1{
    font-size: 14px;
    color: rgb(143, 143, 143);
    font-weight: bold;
  }
  .sp2{
    font-size: 14px;
    color: rgb(143, 143, 143)
  }
  .sp3{
    font-size: 14px;
    color: rgb(71, 71, 71);
    font-weight: 500;
    float: left;
    margin-top: 7px;
  }
  .div{
    margin: 5px 0;
  }
  .div1{
    margin: 18px 0;
  }
  .list{
    margin-top: 23px;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid rgb(196, 196, 196);
    /*min-height: 200px;*/
  }
  .but{
    float: right;
  }
  .but1{
    background: rgb(245, 85, 101);
    border-radius: 3px;
    color: white;
    margin-left: 10px;
  }
  .but2{
    background: rgb(196, 196, 196);
    border-radius: 3px;
    color: white;
    margin-left: 12px;
    border: none;
  }
  .input{
    width: 200px;
    float: right;
  }
  .productLists{
    /*overflow: auto;*/
    min-height: 100px;
  }
  .product{
    margin-top: 10px;
    margin-left: 10px;
    display: inline-block;
    width: 200px;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143);
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .but4{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .group{
    margin-left: 10px;
    font-size: 14px;
  }
  .sp4{
    font-size: 14px;
    font-weight: bold;
    color: rgb(245, 85, 101);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
  }
  .sp6{
    font-size: 12px;
    font-weight: 500;
    color: rgb(143, 143, 143);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
  }
  .sp5{
    margin: 0 4px;
  }
  .addCartBtn{
    background: rgb(245, 85, 101);
    border-radius: 3px;
    color: white;
    border: 0;
  }
  .collectBtn{
    background: rgb(196, 196, 196);
    border-radius: 3px;
    color: white;
    margin-left: 12px;
    border: 0;
  }
  .gp{
    display: inline-block;
  }
  .div_top{
    margin: 12px 0;
  }
  .el-checkbox, >>> .el-checkbox__input {
    white-space: normal;
  }
  .el-checkbox-button--mini >>> .el-checkbox-button__inner{
    background: white;
    margin-left: 10px;
    border: 1px solid white;
  }
  .el-checkbox-button.is-checked >>> .el-checkbox-button__inner{
    color: rgb(245, 85, 101);
    border-top: 1px solid rgb(245, 85, 101);
    border-bottom: 1px solid rgb(245, 85, 101);
    border-right: 1px solid rgb(245, 85, 101);
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    max-width: 100%;
  }
</style>
